import { render } from "./sezioniRead.vue?vue&type=template&id=e19a237a"
import script from "./sezioniRead.vue?vue&type=script&lang=js"
export * from "./sezioniRead.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__